module.exports = __webpack_public_path__ + "img/ícone-casa.01e7b28a.svg";